module.exports = __webpack_public_path__ + "img/ico_rank1-m.4015e900.png";